// extracted by mini-css-extract-plugin
module.exports = {"card":"AuthorCard_card_3njS-","avatar":"AuthorCard_avatar_ci3HO","name":"AuthorCard_name_3_qo6","description":"AuthorCard_description_1oUw1"};